"use client";

import { notFound } from "next/navigation";
import { blogsData } from "@/data/blog";
import { eventsData } from "@/data/events";
import { BannerSection } from "@/components/sections/BannerSection";
import { BlogEventDescription } from "../sections/BlogEventDescription";
import { BannerInformation } from "@/components/ui/BannerInformation";
import { GalleryGrid } from "../../galerie/sections/GalleryGrid";
import { BlogEventHeader } from "../sections/BlogEventHeader";

export default function BlogEventPage({
  params,
}: {
  params: { slug: string };
}) {
  const blog = blogsData.find((blog) => blog.id === params.slug);
  const event = eventsData.find((event) => event.id === params.slug);

  const blogEvent = blog || event;

  if (!blogEvent) {
    return notFound();
  }

  return (
    <main className="flex max-w-[100vw] flex-col">
      <BannerSection title={blogEvent.title} />
      <BannerInformation />
      <BlogEventHeader date={blogEvent.date} />
      <BlogEventDescription content={blogEvent.content} />
      {event && event.images && event.images.length > 0 && (
        <GalleryGrid
          title={event.desktopTitle}
          images={event.images}
          mobileTitle={event.mobileTitle}
        />
      )}
    </main>
  );
}
